import api from './api';
import { SiteConfigResponse, AppVersionResponse, SiteConfig, AppVersion } from '../types/utility';

export const getSiteConfig = async (): Promise<SiteConfigResponse> => {
    const response = await api.get('utility/config');
    return response.data;
};

export const getAppVersion = async (): Promise<AppVersionResponse> => {
    const response = await api.get('utility/version');
    return response.data;
};

export const updateSiteConfig = async (data: Partial<SiteConfig>): Promise<SiteConfigResponse> => {
    const response = await api.put('utility/config', data);
    return response.data;
};

export const updateAppVersion = async (data: Partial<AppVersion>): Promise<AppVersionResponse> => {
    const response = await api.put('utility/version', data);
    return response.data;
};
